import router from '@/router'

const orderModule = {
  state: {
    items: null,
    params: null
  },
  mutations: {
    setAllOrders (state, orders) {
      state.items = orders
    },
    setOrdersParams (state, data) {
      state.params = data
    },
    setOrdersById (state, order) {
      state[order.order_id] = order
    }
  },
  actions: {
    setOrders ({ commit }, orders) {
      commit('setAllOrders', orders)

      setTimeout(function() {
        if(orders) {
          orders.forEach(order => {
            commit('setOrdersById', order)
          })
        }
      }, 0)
    }
  },
  getters: {
    getAllOrders: (state) => {
      return state.items
    },
    getOrdersParams: (state) => {
      return state.params
    },
    getOrderById: (state) => (id) => {
      return state[id]
    },
  }
}

export default orderModule



// WEBPACK FOOTER //
// ./src/store/modules/orders.js